import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { getFeatureToggles, useConfig } from '../../../../state/configuration'
import { PaymentDisabled } from './PaymentDisabled'
import { PaymentFailure } from './PaymentFailure'
import { PaymentPath } from './PaymentPath'
import { PaymentRoute } from './PaymentRoute'

export const PaymentRouter: FunctionComponent = () => {
  const { disableBind } = useConfig(getFeatureToggles)

  return disableBind ? (
    <PaymentDisabled />
  ) : (
    <Routes>
      <Route index element={<PaymentRoute />} />
      <Route path={PaymentPath.PAYMENT_CALLBACK} element={<PaymentFailure />} />
      <Route path='*' element={<Navigate to='..' />} />
    </Routes>
  )
}
